/* @refresh reload */
import { render } from "solid-js/web";
import App from "./App";
import "./index.css";
import { initMsal } from "./auth/msal";
import { captureLockedDealer } from "./shared/lockedDealer";

const root = document.getElementById("root");

if (!root) throw new Error("Root element not found");

async function bootstrap() {
  // Before anything can navigate: the first route change drops a ?dealer= link's query string, and the
  // dealer is not asked for until the summary step.
  captureLockedDealer();

  // Finish any B2C redirect and adopt a cached account before the app (and its API calls) start.
  // No-op when B2C isn't configured (local dev) — the app then runs against the server DevAuth bypass.
  //
  // A redirect error it does not recognise is rethrown. The app renders regardless — signed out, which
  // is what the failed sign-in means — and the error goes to the console; render() not running would
  // show the visitor coming back from a sign-in an empty page.
  try {
    await initMsal();
  } catch (error) {
    console.error("Returning from sign-in failed; continuing signed out.", error);
  }

  // A promise nobody awaited that rejects is otherwise silent. Named here so it at least reaches the console.
  window.addEventListener("unhandledrejection", (e) => console.error("Unhandled rejection:", e.reason));

  // Nobody is bounced to B2C on the way in, and nothing here inspects the hostname: "/" offers all
  // three routes, so the decision belongs to the visitor rather than to their URL. Deciding entry by
  // host — anonymous customers on the public host, a forced B2C sign-in on every other — carries a trap
  // it cannot avoid: a dealer's own CUSTOMER, following a link to the dealer's address, meets a login
  // form for an account they were never going to have. sessionStore resolves the sales deep-link, and
  // the gated pages (dashboard, admin) redirect on their own when no session resolves.
  render(() => <App />, root!);
}

void bootstrap();
